import { FontWeight, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import TrustpilotLogo from '@Assets/logos/trustpilot-logo.svg';

interface TrustpilotTextProps {
  className?: string;
}

export const TrustpilotText = ({ className }: TrustpilotTextProps) => {
  const { t } = useTranslation();

  return (
    <div className={className || 'flex gap-[4px] items-center text-text-main-primary'}>
      <Text.H9 fontWeight={FontWeight.SEMIBOLD}>{t('trustpilotRating')}</Text.H9>
      <Text.H9>{t('trustpilotOutOf')}</Text.H9>
      <img src={TrustpilotLogo} alt={t('trustpilot')} className='h-[18px]' />
    </div>
  );
};

export default TrustpilotText;
